/* tslint:disable */
/* eslint-disable */
export enum BasicDocumentType {
    GDPR = 1,
    GeneralEmployeeInformation = 2,
    OccupationalSafetyDeclaration = 3
}